// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.style-module_errorMessage_JdCxmVaaOrFm9f94Y9Zu {
  margin-top: 0.2rem;
  font-size: 0.7rem;
  color: red;
  position: relative;
  order: 99;
}`, "",{"version":3,"sources":["webpack://./src/components/ErrorHelpText/style.module.scss"],"names":[],"mappings":"AAEA;EACE,kBAAA;EACA,iBAAA;EAEA,UAAA;EACA,kBAAA;EACA,SAAA;AAFF","sourcesContent":["//@import \"~@wfp/ui/src/globals/scss/vars\";\n\n.errorMessage {\n  margin-top: 0.2rem;\n  font-size: 0.7rem;\n  //color: $color__dark-red;\n  color: red;\n  position: relative;\n  order: 99;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"errorMessage": `style-module_errorMessage_JdCxmVaaOrFm9f94Y9Zu`
};
export default ___CSS_LOADER_EXPORT___;
